var AddedRatesModifier = /** @class */ (function () {
    function AddedRatesModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    AddedRatesModifier.prototype.modify = function (content) {
        if (content.rates === undefined || content.rates.add === undefined) {
            return;
        }
        var rates = content.rates.add;
        for (var i = 0; i < rates.length; i++) {
            var rate = rates[i];
            var key = this._modelKeyRepository.addRate(rate.o, rate.id);
            rates[i] = Object.assign({
                type: rate.t,
                value: rate.v
            }, key);
        }
    };
    return AddedRatesModifier;
}());
export default AddedRatesModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/AddedRatesModifier.js